import CardLink from './CardLink'

export default CardLink
